import {IMandateType} from './../../models/user/mandate.model';
import {createAction, props} from '@ngrx/store';
import {User} from 'src/app/models/user/user.model';
import { Patient } from 'vidis-common';

export const setUserAction = createAction('[USER] set user', props<{ user: User }>());
export const setPatientSsinAction = createAction('[USER] set ssin', props<{ ssin: string }>());
export const setPatientAction = createAction('[USER] set patient', props<{ patient: Patient }>());
export const setRedirectUrlAction = createAction('[USER] set redirect url', props<{ url: string }>());
export const setMandateType = createAction('[USER] set user mandate type', props<{mandateType: IMandateType}>());
export const fetchAllPatientMedicalData = createAction('[USER] fetch all patient medical data');
export const clearAllPatientMedicalData = createAction('[USER] clear all patient medical data');
